(function (scope) {
  'use strict';
  const pending = new WeakMap();
  const rooms = new Set(['rc-garage', 'arcade', 'flying-figures', 'playsets']);
  const enabled = root => [185829163319, 190596776247, 190605426999].includes(Number(scope.Shopify?.theme?.id)) && ['unpublished', 'main'].includes(scope.Shopify?.theme?.role) && scope.document?.body?.dataset.storefrontBrand === 'hobbytron' && root?.hasAttribute('data-campaign-drawer') && rooms.has(root.room);
  const parse = html => new scope.DOMParser().parseFromString(html, 'text/html');

  function notificationState(result, sections, root) {
    const doc = parse(sections['cart-notification-product']);
    const wrapper = doc.createElement('div');
    const list = doc.createElement('div');
    wrapper.id = 'cart-notification-product-hobbytron-campaign';
    list.className = 'ht-campaign-cart-lines';
    for (const line of result.verified.lines) {
      const row = doc.getElementById('cart-notification-product-' + line.key);
      if (!row) throw Error('The added cart line could not be rendered.');
      const detail = doc.createElement('p');
      detail.className = 'ht-campaign-cart-line-total';
      detail.textContent = line.quantity + ' × ' + root.money(line.final_price) + ' · ' + root.money(line.final_line_price);
      row.lastElementChild.append(detail);
      list.append(row);
    }
    if (!result.verified.lines.length) throw Error('No verified added lines were returned.');
    wrapper.append(list);
    return {key: 'hobbytron-campaign', sections: {...sections, 'cart-notification-product': wrapper.outerHTML}};
  }

  function renderState(cartUI, result, sections, root) {
    const state = cartUI.localName === 'cart-notification' ? notificationState(result, sections, root) : {...result.response, sections};
    for (const section of cartUI.getSectionsToRender()) {
      const target = cartUI.localName !== 'cart-notification' && section.selector ? scope.document.querySelector(section.selector) : scope.document.getElementById(section.id);
      if (!target || typeof state.sections[section.id] !== 'string') throw Error('A cart section is unavailable.');
      const selector = section.id === 'cart-notification-product' ? '[id="cart-notification-product-hobbytron-campaign"]' : section.selector || '.shopify-section';
      if (!parse(state.sections[section.id]).querySelector(selector)) throw Error('A cart section could not be rendered.');
    }
    cartUI.classList.remove('is-empty');
    cartUI.setAttribute('data-hobbytron-campaign-cart', '');
    cartUI.renderContents(state);
  }

  async function freshSections(ids) {
    const url = new URL(scope.location.href);
    url.searchParams.set('sections', ids.join(','));
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await scope.fetch(url, {headers: {Accept: 'application/json'}, cache: 'no-store', signal: controller.signal});
      if (!response.ok) throw Error('Cart sections could not be refreshed.');
      return await response.json();
    } finally { clearTimeout(timer); }
  }

  function purchase({root, checkout, transact, source, variantId}) {
    if (pending.has(root)) return pending.get(root);
    const task = Promise.resolve().then(async () => {
      const cartUI = root.querySelector('arcade-purchase-form')?.cart;
      if (!checkout && (!cartUI?.renderContents || !cartUI?.getSectionsToRender)) throw Error('The cart could not be opened. Please reload this page and try again. No items were added.');
      const sections = cartUI?.getSectionsToRender().map(section => section.id) || [];
      cartUI?.setActiveElement(root.querySelector(checkout ? '[data-checkout]' : '[data-atc]'));
      const result = await transact(sections);
      if (!result.verified?.priceVerified) return result;
      if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, {source, productVariantId: variantId, cartData: result.cart});
      if (checkout) { scope.location.assign(root.base + 'checkout'); return result; }
      try {
        try { renderState(cartUI, result, result.response?.sections || {}, root); }
        catch (_) { renderState(cartUI, result, await freshSections(sections), root); }
      } catch (_) {
        result.message = 'Your items were added. The cart preview could not load; use View cart in the header to review them. Do not add them again.';
        result.presentationError = true;
      }
      return result;
    }).finally(() => pending.delete(root));
    pending.set(root, task);
    return task;
  }

  const api = {enabled, purchase, notificationState};
  if (typeof module === 'object' && module.exports) module.exports = api;
  else scope.HobbytronCampaignCartUI = api;
})(typeof window === 'undefined' ? globalThis : window);
